export const updateStatusMessage = {
	success: {
		approved: {
			title: "¡Inventario concluido!",
			message: "Inventario finalizado",
		},
		in_review: {
			title: "¡Inventario enviado para revisión!",
			message: "El inventario será revisado por un responsable",
		},
	},
	error: {
		approved: {
			title: "¡Ops, algo salió mal!",
			message: "Inventario no finalizado",
		},
		in_review: {
			title: "¡Ops, algo salió mal!",
			message: "Inventario no enviado para revisión",
		},
	},
	actions: {
		goHome: "Volver a la página inicial",
		backToResume: "Volver al resumen",
		createAnotherInventory: "Crear otro inventario",
	},
};
